import { JackpotLevel, JackpotValue2 } from "./api";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { MoneyFormatter } from "./MoneyFormatter";
import { LogGroup, Scale, Size } from "./MyHelpers";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { ScreenProtocol, ScreenProtocolScope } from "./ScreenProtocol";
import { ZIndex } from "./ZIndex";

export class JackpotDisplayPaytable extends  IJackpotDisplay 
{

    protected view: HTMLElement = null;
	protected viewSize: Size = null;


	protected commonpath: string = null;
	protected basepath: string = null;
	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	protected screenProtocol: ScreenProtocol = null;

	protected logGroup: LogGroup = new LogGroup("JackpotDisplayPaytable");

	protected systemContext: ISystemContext = null;

	

	public constructor(params: JackpotDisplayParams) {
		super(params);

		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayPaytable");

		this.resid = params.resid.Add("JackpotDisplayPaytable");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayPaytable");

		this.screenProtocol = params.screenProtocol;
	
		this.viewSize = params.viewSize;

		// this would be "view" with jackpot frames
		this.view = document.createElement("div");
		this.view.classList.add(this.resid.ID());
		this.view.style.position = "absolute";
		this.view.style.top = Scale.Ypx(0);
		this.view.style.left = Scale.Xpx(0);
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";
		this.view.style.zIndex = "" + ZIndex.JackpotDisplay;

		
		
	}	

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		
	
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {

	}

	// deleted too much, this is how this particular game gets displayed to screen,
	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void {
		
	}

	public StopAnimations(): void {
		
	}

	public StartAnimations(): void {

		
	}

	public override UpdateValues(jackpotValues: JackpotValue2[]): void {
		
	}

	public TitleHide(){
		
	}
	public TitleShow(){
		
	}
	
	public override Reset() {
		console.log("Reset JackpotValues");
	}

	public override Resume() {
		console.log("Resume JackpotValues");
	}

	public override Pause() {
		console.log("Pause JackpotValues");
	}

    public ResetJackpot(jackpotLevel: string) {}
}
